// @ts-nocheck
import { PopulateApiParameter, chain } from "@insite/client-framework/Store/Pages/OrderHistory/Handlers/Reorder";
import handleLinePropertiesForReorder from "@store/Framework/Common/Utilities/handleLinePropertiesForReorder";
import removeNotInCatalogLines from "@store/Framework/Common/Utilities/removeNotInCatalogLines";
import { addToChainAfter } from "@toolkit/Modules/client-framework/HandlerCreator";

addToChainAfter(chain, PopulateApiParameter, props => {
    const order = props.getState().pages.orderStatus.order;

    if (order) {
        handleLinePropertiesForReorder(order.orderLines, props.apiParameter.cartLines);
        props.apiParameter.cartLines = removeNotInCatalogLines(props.apiParameter.cartLines);
    }
});
